export const CURRENCY_META: Record<
	string,
	{
		name: string
		country: string
		symbol: string
		maximumFractionDigits: number
	}
> = {
	USD: {
		name: "US Dollar",
		country: "United States",
		symbol: "$",
		maximumFractionDigits: 2,
	},
	INR: {
		name: "Indian Rupee",
		country: "India",
		symbol: "₹",
		maximumFractionDigits: 2,
	},
	IDR: {
		name: "Indonesian Rupiah",
		country: "Indonesia",
		symbol: "Rp",
		maximumFractionDigits: 2,
	},
	EUR: {
		name: "Euro",
		country: "European Union",
		symbol: "€",
		maximumFractionDigits: 2,
	},
	GBP: {
		name: "Pound Sterling",
		country: "United Kingdom",
		symbol: "£",
		maximumFractionDigits: 2,
	},
	JPY: {
		name: "Japanese Yen",
		country: "Japan",
		symbol: "¥",
		maximumFractionDigits: 0,
	},
	KRW: {
		name: "South Korean Won",
		country: "South Korea",
		symbol: "₩",
		maximumFractionDigits: 0,
	},
	VND: {
		name: "Vietnamese Dong",
		country: "Vietnam",
		symbol: "₫",
		maximumFractionDigits: 0,
	},
	KWD: {
		name: "Kuwaiti Dinar",
		country: "Kuwait",
		symbol: "KD",
		maximumFractionDigits: 3,
	},
	BHD: {
		name: "Bahraini Dinar",
		country: "Bahrain",
		symbol: ".د.ب",
		maximumFractionDigits: 3,
	},
	OMR: {
		name: "Omani Rial",
		country: "Oman",
		symbol: "﷼",
		maximumFractionDigits: 3,
	},
	TND: {
		name: "Tunisian Dinar",
		country: "Tunisia",
		symbol: "د.ت",
		maximumFractionDigits: 3,
	},
	CLF: {
		name: "Unidad de Fomento",
		country: "Chile",
		symbol: "UF",
		maximumFractionDigits: 4,
	},

	// Additional ISO 4217 currencies
	AED: {
		name: "UAE Dirham",
		country: "United Arab Emirates",
		symbol: "د.إ",
		maximumFractionDigits: 2,
	},
	AFN: {
		name: "Afghan Afghani",
		country: "Afghanistan",
		symbol: "؋",
		maximumFractionDigits: 2,
	},
	ALL: {
		name: "Albanian Lek",
		country: "Albania",
		symbol: "L",
		maximumFractionDigits: 2,
	},
	AMD: {
		name: "Armenian Dram",
		country: "Armenia",
		symbol: "֏",
		maximumFractionDigits: 2,
	},
	ANG: {
		name: "Netherlands Antillean Guilder",
		country: "Curaçao, Sint Maarten",
		symbol: "ƒ",
		maximumFractionDigits: 2,
	},
	AOA: {
		name: "Angolan Kwanza",
		country: "Angola",
		symbol: "Kz",
		maximumFractionDigits: 2,
	},
	ARS: {
		name: "Argentine Peso",
		country: "Argentina",
		symbol: "AR$",
		maximumFractionDigits: 2,
	},
	AUD: {
		name: "Australian Dollar",
		country: "Australia",
		symbol: "AU$",
		maximumFractionDigits: 2,
	},
	AWG: {
		name: "Aruban Florin",
		country: "Aruba",
		symbol: "Afl.",
		maximumFractionDigits: 2,
	},
	AZN: {
		name: "Azerbaijani Manat",
		country: "Azerbaijan",
		symbol: "₼",
		maximumFractionDigits: 2,
	},
	BAM: {
		name: "Bosnia-Herzegovina Convertible Mark",
		country: "Bosnia and Herzegovina",
		symbol: "KM",
		maximumFractionDigits: 2,
	},
	BBD: {
		name: "Barbadian Dollar",
		country: "Barbados",
		symbol: "Bds$",
		maximumFractionDigits: 2,
	},
	BDT: {
		name: "Bangladeshi Taka",
		country: "Bangladesh",
		symbol: "৳",
		maximumFractionDigits: 2,
	},
	BGN: {
		name: "Bulgarian Lev",
		country: "Bulgaria",
		symbol: "лв",
		maximumFractionDigits: 2,
	},
	BIF: {
		name: "Burundian Franc",
		country: "Burundi",
		symbol: "FBu",
		maximumFractionDigits: 0,
	},
	BMD: {
		name: "Bermudian Dollar",
		country: "Bermuda",
		symbol: "BD$",
		maximumFractionDigits: 2,
	},
	BND: {
		name: "Brunei Dollar",
		country: "Brunei",
		symbol: "B$",
		maximumFractionDigits: 2,
	},
	BOB: {
		name: "Bolivian Boliviano",
		country: "Bolivia",
		symbol: "Bs.",
		maximumFractionDigits: 2,
	},
	BOV: {
		name: "Bolivian Mvdol",
		country: "Bolivia",
		symbol: "BOV",
		maximumFractionDigits: 2,
	},
	BRL: {
		name: "Brazilian Real",
		country: "Brazil",
		symbol: "R$",
		maximumFractionDigits: 2,
	},
	BSD: {
		name: "Bahamian Dollar",
		country: "Bahamas",
		symbol: "B$",
		maximumFractionDigits: 2,
	},
	BTN: {
		name: "Bhutanese Ngultrum",
		country: "Bhutan",
		symbol: "Nu.",
		maximumFractionDigits: 2,
	},
	BWP: {
		name: "Botswana Pula",
		country: "Botswana",
		symbol: "P",
		maximumFractionDigits: 2,
	},
	BYN: {
		name: "Belarusian Ruble",
		country: "Belarus",
		symbol: "Br",
		maximumFractionDigits: 2,
	},
	BZD: {
		name: "Belize Dollar",
		country: "Belize",
		symbol: "BZ$",
		maximumFractionDigits: 2,
	},
	CAD: {
		name: "Canadian Dollar",
		country: "Canada",
		symbol: "CA$",
		maximumFractionDigits: 2,
	},
	CDF: {
		name: "Congolese Franc",
		country: "Democratic Republic of the Congo",
		symbol: "FC",
		maximumFractionDigits: 2,
	},
	CHE: {
		name: "WIR Euro",
		country: "Switzerland",
		symbol: "CHE",
		maximumFractionDigits: 2,
	},
	CHF: {
		name: "Swiss Franc",
		country: "Switzerland",
		symbol: "CHF",
		maximumFractionDigits: 2,
	},
	CHW: {
		name: "WIR Franc",
		country: "Switzerland",
		symbol: "CHW",
		maximumFractionDigits: 2,
	},
	CLP: {
		name: "Chilean Peso",
		country: "Chile",
		symbol: "CL$",
		maximumFractionDigits: 0,
	},
	CNY: {
		name: "Chinese Yuan",
		country: "China",
		symbol: "CN¥",
		maximumFractionDigits: 2,
	},
	COP: {
		name: "Colombian Peso",
		country: "Colombia",
		symbol: "COL$",
		maximumFractionDigits: 2,
	},
	COU: {
		name: "Unidad de Valor Real",
		country: "Colombia",
		symbol: "COU",
		maximumFractionDigits: 2,
	},
	CRC: {
		name: "Costa Rican Colón",
		country: "Costa Rica",
		symbol: "₡",
		maximumFractionDigits: 2,
	},
	CUC: {
		name: "Cuban Convertible Peso",
		country: "Cuba",
		symbol: "CUC$",
		maximumFractionDigits: 2,
	},
	CUP: {
		name: "Cuban Peso",
		country: "Cuba",
		symbol: "$MN",
		maximumFractionDigits: 2,
	},
	CVE: {
		name: "Cape Verdean Escudo",
		country: "Cape Verde",
		symbol: "Esc",
		maximumFractionDigits: 2,
	},
	CZK: {
		name: "Czech Koruna",
		country: "Czech Republic",
		symbol: "Kč",
		maximumFractionDigits: 2,
	},
	DJF: {
		name: "Djiboutian Franc",
		country: "Djibouti",
		symbol: "Fdj",
		maximumFractionDigits: 0,
	},
	DKK: {
		name: "Danish Krone",
		country: "Denmark",
		symbol: "kr",
		maximumFractionDigits: 2,
	},
	DOP: {
		name: "Dominican Peso",
		country: "Dominican Republic",
		symbol: "RD$",
		maximumFractionDigits: 2,
	},
	DZD: {
		name: "Algerian Dinar",
		country: "Algeria",
		symbol: "د.ج",
		maximumFractionDigits: 2,
	},
	EGP: {
		name: "Egyptian Pound",
		country: "Egypt",
		symbol: "E£",
		maximumFractionDigits: 2,
	},
	ERN: {
		name: "Eritrean Nakfa",
		country: "Eritrea",
		symbol: "Nkf",
		maximumFractionDigits: 2,
	},
	ETB: {
		name: "Ethiopian Birr",
		country: "Ethiopia",
		symbol: "Br",
		maximumFractionDigits: 2,
	},
	FJD: {
		name: "Fijian Dollar",
		country: "Fiji",
		symbol: "FJ$",
		maximumFractionDigits: 2,
	},
	FKP: {
		name: "Falkland Islands Pound",
		country: "Falkland Islands",
		symbol: "FK£",
		maximumFractionDigits: 2,
	},
	GEL: {
		name: "Georgian Lari",
		country: "Georgia",
		symbol: "₾",
		maximumFractionDigits: 2,
	},
	GHS: {
		name: "Ghanaian Cedi",
		country: "Ghana",
		symbol: "₵",
		maximumFractionDigits: 2,
	},
	GIP: {
		name: "Gibraltar Pound",
		country: "Gibraltar",
		symbol: "£",
		maximumFractionDigits: 2,
	},
	GMD: {
		name: "Gambian Dalasi",
		country: "Gambia",
		symbol: "D",
		maximumFractionDigits: 2,
	},
	GNF: {
		name: "Guinean Franc",
		country: "Guinea",
		symbol: "FG",
		maximumFractionDigits: 0,
	},
	GTQ: {
		name: "Guatemalan Quetzal",
		country: "Guatemala",
		symbol: "Q",
		maximumFractionDigits: 2,
	},
	GYD: {
		name: "Guyanese Dollar",
		country: "Guyana",
		symbol: "GY$",
		maximumFractionDigits: 2,
	},
	HKD: {
		name: "Hong Kong Dollar",
		country: "Hong Kong",
		symbol: "HK$",
		maximumFractionDigits: 2,
	},
	HNL: {
		name: "Honduran Lempira",
		country: "Honduras",
		symbol: "L",
		maximumFractionDigits: 2,
	},
	HTG: {
		name: "Haitian Gourde",
		country: "Haiti",
		symbol: "G",
		maximumFractionDigits: 2,
	},
	HUF: {
		name: "Hungarian Forint",
		country: "Hungary",
		symbol: "Ft",
		maximumFractionDigits: 2,
	},
	ILS: {
		name: "Israeli New Shekel",
		country: "Israel",
		symbol: "₪",
		maximumFractionDigits: 2,
	},
	IQD: {
		name: "Iraqi Dinar",
		country: "Iraq",
		symbol: "ع.د",
		maximumFractionDigits: 3,
	},
	IRR: {
		name: "Iranian Rial",
		country: "Iran",
		symbol: "﷼",
		maximumFractionDigits: 2,
	},
	ISK: {
		name: "Icelandic Króna",
		country: "Iceland",
		symbol: "kr",
		maximumFractionDigits: 0,
	},
	JMD: {
		name: "Jamaican Dollar",
		country: "Jamaica",
		symbol: "J$",
		maximumFractionDigits: 2,
	},
	JOD: {
		name: "Jordanian Dinar",
		country: "Jordan",
		symbol: "JD",
		maximumFractionDigits: 3,
	},
	KES: {
		name: "Kenyan Shilling",
		country: "Kenya",
		symbol: "KSh",
		maximumFractionDigits: 2,
	},
	KGS: {
		name: "Kyrgyzstani Som",
		country: "Kyrgyzstan",
		symbol: "с",
		maximumFractionDigits: 2,
	},
	KHR: {
		name: "Cambodian Riel",
		country: "Cambodia",
		symbol: "៛",
		maximumFractionDigits: 2,
	},
	KMF: {
		name: "Comorian Franc",
		country: "Comoros",
		symbol: "CF",
		maximumFractionDigits: 0,
	},
	KPW: {
		name: "North Korean Won",
		country: "North Korea",
		symbol: "₩",
		maximumFractionDigits: 2,
	},
	KYD: {
		name: "Cayman Islands Dollar",
		country: "Cayman Islands",
		symbol: "CI$",
		maximumFractionDigits: 2,
	},
	KZT: {
		name: "Kazakhstani Tenge",
		country: "Kazakhstan",
		symbol: "₸",
		maximumFractionDigits: 2,
	},
	LAK: {
		name: "Lao Kip",
		country: "Laos",
		symbol: "₭",
		maximumFractionDigits: 2,
	},
	LBP: {
		name: "Lebanese Pound",
		country: "Lebanon",
		symbol: "ل.ل",
		maximumFractionDigits: 2,
	},
	LKR: {
		name: "Sri Lankan Rupee",
		country: "Sri Lanka",
		symbol: "Rs",
		maximumFractionDigits: 2,
	},
	LRD: {
		name: "Liberian Dollar",
		country: "Liberia",
		symbol: "L$",
		maximumFractionDigits: 2,
	},
	LSL: {
		name: "Lesotho Loti",
		country: "Lesotho",
		symbol: "L",
		maximumFractionDigits: 2,
	},
	LYD: {
		name: "Libyan Dinar",
		country: "Libya",
		symbol: "ل.د",
		maximumFractionDigits: 3,
	},
	MAD: {
		name: "Moroccan Dirham",
		country: "Morocco",
		symbol: "د.م.",
		maximumFractionDigits: 2,
	},
	MDL: {
		name: "Moldovan Leu",
		country: "Moldova",
		symbol: "L",
		maximumFractionDigits: 2,
	},
	MGA: {
		name: "Malagasy Ariary",
		country: "Madagascar",
		symbol: "Ar",
		maximumFractionDigits: 0,
	},
	MKD: {
		name: "Macedonian Denar",
		country: "North Macedonia",
		symbol: "ден",
		maximumFractionDigits: 2,
	},
	MMK: {
		name: "Myanmar Kyat",
		country: "Myanmar",
		symbol: "K",
		maximumFractionDigits: 2,
	},
	MNT: {
		name: "Mongolian Tugrik",
		country: "Mongolia",
		symbol: "₮",
		maximumFractionDigits: 2,
	},
	MOP: {
		name: "Macanese Pataca",
		country: "Macau",
		symbol: "MOP$",
		maximumFractionDigits: 2,
	},
	MRU: {
		name: "Mauritanian Ouguiya",
		country: "Mauritania",
		symbol: "UM",
		maximumFractionDigits: 2,
	},
	MUR: {
		name: "Mauritian Rupee",
		country: "Mauritius",
		symbol: "₨",
		maximumFractionDigits: 2,
	},
	MVR: {
		name: "Maldivian Rufiyaa",
		country: "Maldives",
		symbol: "Rf",
		maximumFractionDigits: 2,
	},
	MWK: {
		name: "Malawian Kwacha",
		country: "Malawi",
		symbol: "MK",
		maximumFractionDigits: 2,
	},
	MXN: {
		name: "Mexican Peso",
		country: "Mexico",
		symbol: "Mex$",
		maximumFractionDigits: 2,
	},
	MXV: {
		name: "Mexican Unidad de Inversión",
		country: "Mexico",
		symbol: "UDI",
		maximumFractionDigits: 2,
	},
	MYR: {
		name: "Malaysian Ringgit",
		country: "Malaysia",
		symbol: "RM",
		maximumFractionDigits: 2,
	},
	MZN: {
		name: "Mozambican Metical",
		country: "Mozambique",
		symbol: "MT",
		maximumFractionDigits: 2,
	},
	NAD: {
		name: "Namibian Dollar",
		country: "Namibia",
		symbol: "N$",
		maximumFractionDigits: 2,
	},
	NGN: {
		name: "Nigerian Naira",
		country: "Nigeria",
		symbol: "₦",
		maximumFractionDigits: 2,
	},
	NIO: {
		name: "Nicaraguan Córdoba",
		country: "Nicaragua",
		symbol: "C$",
		maximumFractionDigits: 2,
	},
	NOK: {
		name: "Norwegian Krone",
		country: "Norway",
		symbol: "kr",
		maximumFractionDigits: 2,
	},
	NPR: {
		name: "Nepalese Rupee",
		country: "Nepal",
		symbol: "रू",
		maximumFractionDigits: 2,
	},
	NZD: {
		name: "New Zealand Dollar",
		country: "New Zealand",
		symbol: "NZ$",
		maximumFractionDigits: 2,
	},
	PAB: {
		name: "Panamanian Balboa",
		country: "Panama",
		symbol: "B/.",
		maximumFractionDigits: 2,
	},
	PEN: {
		name: "Peruvian Sol",
		country: "Peru",
		symbol: "S/",
		maximumFractionDigits: 2,
	},
	PGK: {
		name: "Papua New Guinean Kina",
		country: "Papua New Guinea",
		symbol: "K",
		maximumFractionDigits: 2,
	},
	PHP: {
		name: "Philippine Peso",
		country: "Philippines",
		symbol: "₱",
		maximumFractionDigits: 2,
	},
	PKR: {
		name: "Pakistani Rupee",
		country: "Pakistan",
		symbol: "Rs",
		maximumFractionDigits: 2,
	},
	PLN: {
		name: "Polish Złoty",
		country: "Poland",
		symbol: "zł",
		maximumFractionDigits: 2,
	},
	PYG: {
		name: "Paraguayan Guarani",
		country: "Paraguay",
		symbol: "₲",
		maximumFractionDigits: 0,
	},
	QAR: {
		name: "Qatari Riyal",
		country: "Qatar",
		symbol: "QR",
		maximumFractionDigits: 2,
	},
	RON: {
		name: "Romanian Leu",
		country: "Romania",
		symbol: "lei",
		maximumFractionDigits: 2,
	},
	RSD: {
		name: "Serbian Dinar",
		country: "Serbia",
		symbol: "дин.",
		maximumFractionDigits: 2,
	},
	RUB: {
		name: "Russian Ruble",
		country: "Russia",
		symbol: "₽",
		maximumFractionDigits: 2,
	},
	RWF: {
		name: "Rwandan Franc",
		country: "Rwanda",
		symbol: "RF",
		maximumFractionDigits: 0,
	},
	SAR: {
		name: "Saudi Riyal",
		country: "Saudi Arabia",
		symbol: "SR",
		maximumFractionDigits: 2,
	},
	SBD: {
		name: "Solomon Islands Dollar",
		country: "Solomon Islands",
		symbol: "SI$",
		maximumFractionDigits: 2,
	},
	SCR: {
		name: "Seychellois Rupee",
		country: "Seychelles",
		symbol: "SR",
		maximumFractionDigits: 2,
	},
	SDG: {
		name: "Sudanese Pound",
		country: "Sudan",
		symbol: "ج.س.",
		maximumFractionDigits: 2,
	},
	SEK: {
		name: "Swedish Krona",
		country: "Sweden",
		symbol: "kr",
		maximumFractionDigits: 2,
	},
	SGD: {
		name: "Singapore Dollar",
		country: "Singapore",
		symbol: "S$",
		maximumFractionDigits: 2,
	},
	SHP: {
		name: "Saint Helena Pound",
		country: "Saint Helena",
		symbol: "£",
		maximumFractionDigits: 2,
	},
	SLE: {
		name: "Sierra Leonean Leone",
		country: "Sierra Leone",
		symbol: "Le",
		maximumFractionDigits: 2,
	},
	SOS: {
		name: "Somali Shilling",
		country: "Somalia",
		symbol: "Sh.So.",
		maximumFractionDigits: 2,
	},
	SRD: {
		name: "Surinamese Dollar",
		country: "Suriname",
		symbol: "SRD$",
		maximumFractionDigits: 2,
	},
	SSP: {
		name: "South Sudanese Pound",
		country: "South Sudan",
		symbol: "£SS",
		maximumFractionDigits: 2,
	},
	STN: {
		name: "São Tomé and Príncipe Dobra",
		country: "São Tomé and Príncipe",
		symbol: "Db",
		maximumFractionDigits: 2,
	},
	SVC: {
		name: "Salvadoran Colón",
		country: "El Salvador",
		symbol: "₡",
		maximumFractionDigits: 2,
	},
	SYP: {
		name: "Syrian Pound",
		country: "Syria",
		symbol: "ل.س",
		maximumFractionDigits: 2,
	},
	SZL: {
		name: "Swazi Lilangeni",
		country: "Eswatini",
		symbol: "E",
		maximumFractionDigits: 2,
	},
	THB: {
		name: "Thai Baht",
		country: "Thailand",
		symbol: "฿",
		maximumFractionDigits: 2,
	},
	TJS: {
		name: "Tajikistani Somoni",
		country: "Tajikistan",
		symbol: "S.M.",
		maximumFractionDigits: 2,
	},
	TMT: {
		name: "Turkmenistan Manat",
		country: "Turkmenistan",
		symbol: "m",
		maximumFractionDigits: 2,
	},
	TOP: {
		name: "Tongan Paʻanga",
		country: "Tonga",
		symbol: "T$",
		maximumFractionDigits: 2,
	},
	TRY: {
		name: "Turkish Lira",
		country: "Turkey",
		symbol: "₺",
		maximumFractionDigits: 2,
	},
	TTD: {
		name: "Trinidad and Tobago Dollar",
		country: "Trinidad and Tobago",
		symbol: "TT$",
		maximumFractionDigits: 2,
	},
	TWD: {
		name: "New Taiwan Dollar",
		country: "Taiwan",
		symbol: "NT$",
		maximumFractionDigits: 2,
	},
	TZS: {
		name: "Tanzanian Shilling",
		country: "Tanzania",
		symbol: "TSh",
		maximumFractionDigits: 2,
	},
	UAH: {
		name: "Ukrainian Hryvnia",
		country: "Ukraine",
		symbol: "₴",
		maximumFractionDigits: 2,
	},
	UGX: {
		name: "Ugandan Shilling",
		country: "Uganda",
		symbol: "USh",
		maximumFractionDigits: 0,
	},
	USN: {
		name: "US Dollar (Next Day)",
		country: "United States",
		symbol: "US$ (N)",
		maximumFractionDigits: 2,
	},
	UYU: {
		name: "Uruguayan Peso",
		country: "Uruguay",
		symbol: "$U",
		maximumFractionDigits: 2,
	},
	UZS: {
		name: "Uzbekistani Som",
		country: "Uzbekistan",
		symbol: "so'm",
		maximumFractionDigits: 2,
	},
	VES: {
		name: "Venezuelan Bolívar Soberano",
		country: "Venezuela",
		symbol: "Bs.S",
		maximumFractionDigits: 2,
	},
	VUV: {
		name: "Vanuatu Vatu",
		country: "Vanuatu",
		symbol: "VT",
		maximumFractionDigits: 0,
	},
	WST: {
		name: "Samoan Tala",
		country: "Samoa",
		symbol: "WS$",
		maximumFractionDigits: 2,
	},
	XAF: {
		name: "Central African CFA Franc",
		country: "Central African Economic and Monetary Community",
		symbol: "FCFA",
		maximumFractionDigits: 0,
	},
	XCD: {
		name: "East Caribbean Dollar",
		country: "Eastern Caribbean Currency Union",
		symbol: "EC$",
		maximumFractionDigits: 2,
	},
	XDR: {
		name: "Special Drawing Rights",
		country: "International Monetary Fund",
		symbol: "SDR",
		maximumFractionDigits: 2,
	},
	XOF: {
		name: "West African CFA Franc",
		country: "West African Economic and Monetary Union",
		symbol: "CFA",
		maximumFractionDigits: 0,
	},
	XPF: {
		name: "CFP Franc",
		country: "French Overseas Territories",
		symbol: "F",
		maximumFractionDigits: 0,
	},
	YER: {
		name: "Yemeni Rial",
		country: "Yemen",
		symbol: "﷼",
		maximumFractionDigits: 2,
	},
	ZAR: {
		name: "South African Rand",
		country: "South Africa",
		symbol: "R",
		maximumFractionDigits: 2,
	},
	ZMW: {
		name: "Zambian Kwacha",
		country: "Zambia",
		symbol: "K",
		maximumFractionDigits: 2,
	},
	ZWL: {
		name: "Zimbabwean Dollar",
		country: "Zimbabwe",
		symbol: "ZW$",
		maximumFractionDigits: 2,
	},
}

export function ltrim(str: string, trimWhat: string) {
	return str.replace(new RegExp(`^${trimWhat}+`), "")
}

export function rtrim(str: string, trimWhat: string) {
	return str.replace(new RegExp(`${trimWhat}+$`), "")
}

export function arrayFill<T>(length: number, fillWith: T) {
	if (length < 0) {
		throw new Error("Array length can not be negative to fill")
	}
	return Array.from({ length }, () => fillWith)
}

export function getMaximumFractionDigits(formatter: Intl.NumberFormat): number {
	const { currency, maximumFractionDigits } = formatter.resolvedOptions()
	if (typeof maximumFractionDigits === "number" && maximumFractionDigits > 0) {
		return maximumFractionDigits
	}
	if (
		currency &&
		CURRENCY_META[currency]?.maximumFractionDigits !== undefined
	) {
		return CURRENCY_META[currency].maximumFractionDigits
	}
	return 0
}
